import urljoin from 'url-join';

export const baseURL = '/research/expertise-engine';

// PUBLIC_API_URL = http://vpr-db2.dc.sfu.ca/api/public/
export const PUBLIC_API_URL = urljoin(baseURL, 'api/public/');

// PROTECTED_API_URL = http://vpr-db2.dc.sfu.ca/api/protected/
export const PROTECTED_API_URL = urljoin(baseURL, 'api/protected/');

export const DJANGO_LOGIN_URL = urljoin(baseURL, 'accounts/login/');
export const DJANGO_LOGOUT_URL = urljoin(baseURL, 'accounts/logout/');

export const LOGIN_SESSION_KEY = 'loggedIn';
export const REACT_LOGIN_URL = '/login';
export const REACT_LOGOUT_URL = '/logout';